// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/Checkbox/Checkbox.less
// module id = 885
// module chunks = 0